/* eslint-disable */
const getters = {
  getSendMethods(state) {
    return state.data;
  },

  getActiveSendMethods(state) {
    return state.data.filter(({ active }) => active === 1);
  },
};

export default getters;
